// src/components/shared/AddToolbarLink.js
// Toolbar "Add ..." button used in all config view tables.
// Renders a compact icon+label button that navigates to an add-record route.
//
// Usage:
//   renderTopToolbarCustomActions={() => (
//     <AddToolbarLink to="/AddFileTransfer" label="Add Transfer" />
//   )}

import React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";

const AddToolbarLink = ({ to, label, state }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-start", pl: "15px" }}>
      <Button
        variant="outlined"
        color="primary"
        size="small"
        startIcon={<AddIcon fontSize="small" />}
        onClick={() => navigate(to, state ? { state } : undefined)}
      >
        {label}
      </Button>
    </Box>
  );
};

export default AddToolbarLink;
